import { render, staticRenderFns } from "./AISettings.vue?vue&type=template&id=25e32fdf&"
import script from "./AISettings.vue?vue&type=script&lang=ts&"
export * from "./AISettings.vue?vue&type=script&lang=ts&"
import style0 from "./AISettings.vue?vue&type=style&index=0&id=25e32fdf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports